<template>
    <div class="my-mbinfo">
        <van-nav-bar :title="title" style="background-color: #EEEEEE;" left-text="" @click-left="onClickLeft" left-arrow
                     :fixed="true">
        </van-nav-bar>
        <div style="margin-top: -8px">
            <van-swipe height="350" width="100%" indicator-color="white" @change="onChange">
                <van-swipe-item v-for="item in cards" style="background-color: #EEEEEE">
                    <div style="height: 370px;background-color: #ffffff;padding-top: 3px">
                        <div style="background-color: #1356FA;margin: 8px 15px;;height: 120px;padding: 16px;color: #ffffff">
                            <div style="display: flex;flex-direction: row;justify-content: space-between;font-size: 13px;">
                                <span>会员卡: {{item.cardName}}</span>
                                <span>{{item.cardNo}}</span>
                            </div>
                            <div style="display: flex;flex-direction: row;justify-content: space-between;font-size: 13px;margin-top: 30px">
                                <span>余额: {{item.balance}}</span>
                                <span>赠送金: {{item.give==null?'0':item.give}}</span>
                            </div>
                        </div>
                        <div class="card-btn">
                            <span style="width: 50px;">充值</span>
                            <span style="width: 38px;color: #ff4d51">|</span>
                            <span style="width: 50px;">付款</span>
                        </div>
                        <div style="font-size: 13px;padding: 8px 25px 0px 25px;display: flex;flex-direction: row;justify-content: space-between">
                            <span>{{item.deptName}}</span>
                            <span>开卡时间: {{item.createTime}}</span>
                        </div>
                        <div style="padding: 8px 23px 0px 23px;">
                            <img src="./../../assets/txm.jpg" style="width: 400px;height: 110px">
                        </div>
                    </div>
                </van-swipe-item>
                <div class="custom-indicator" slot="indicator" style="font-size: 11px">
                    <span style="padding: 1px 3px;background-color: #f0f0f0">{{ current + 1 }}/{{cards.length}}</span>
                </div>
            </van-swipe>
        </div>
    </div>
</template>

<script>
    import {getCookie, getDeptId, getDeptName} from "../../utils/auth";

    export default {
        data() {
            return {
                title: '我的会员卡',
                deptId: '',
                token: '',
                cards: [],
                current: 0,
            };
        },
        async created() {
            document.title = getDeptName()
            this.deptId = getDeptId()
            this.token = getCookie("spmToken")
            this.getMemberCards()
        },
        methods: {
            async getMemberCards() {
                let data = {
                    token: this.token,
                    deptId: this.deptId
                }
                let res = await this.$get("/spm/getSpmMemberCards", data)
                this.cards = res.cards
            },
            onChange(index) {
                this.current = index;
            },
            onClickLeft() {
                if (window.history.length > 1) {
                    this.$router.back();
                } else {
                    this.$router.push('/home/' + this.deptId)
                }
            },
        },
    };
</script>

<style lang="scss" scoped>

    .my-mbinfo {
        margin: 0 auto;
        height: 100%;
        position: relative;
        background-color: #EEEEEE;
        padding-top: 53px;
    }

    .custom-indicator {
        position: relative;
        right: 0px;
        text-align: right;
        padding-right: 10px;
        padding-bottom: 5px;
    }
    .card-btn{
        height: 40px;
        font-size: 16px;
        line-height: 40px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        text-align: center;
        margin-bottom: 16px;
    }

</style>
